<template>
    <div class="vue-skeleton">
        <ul>
            <li>
                <div class="title"></div>
                <div class="time"></div>
                <div class="teacher"></div>
            </li>
            <li>
                <div class="title"></div>
                <div class="time"></div>
                <div class="teacher"></div>
            </li>
            <li>
                <div class="title"></div>
                <div class="time"></div>
                <div class="teacher"></div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'SkeletonList'
};
</script>
<style lang="less">
.vue-skeleton {
    position: relative;
    z-index: 100;
    width: 1182px;
    margin: 0 auto;

    ul {
        list-style: none;
    }

    li {
        padding: 42px 36px 28px;

        .title {
            width: 35%;
            height: 36px;
            background-color: #f2f2f2;
            margin-bottom: 20px;
        }

        .time {
            width: 65%;
            height: 36px;
            background-color: #f2f2f2;
            margin-bottom: 20px;
        }

        .teacher {
            width: 100%;
            height: 36px;
            background-color: #f2f2f2;
        }
    }
}
</style>
